import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./CloseOrderModal.css"
import {  useState } from 'react';
import Swal from "sweetalert2";

//LOG FUNCTION
import { storeOrderLog } from "../../Helper_Library.js";


const CloseOrderModal = ({ show, requestClose, orderID }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [technicalReport, setTechnicalReport] = useState(null);
    const [counterDevice, setcounterDevice] = useState(null);
    const [serviceType, setServiceType] = useState(null);
    
    const [objOrder, setObjOrder] = useState([]);


    const requestOrderInfo = async () =>{

        const endpoint = "getOrderByID?order_id=" + orderID;


        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        const responseContent = await response.json();

        const metadata = JSON.parse(responseContent.metadata);
        setObjOrder(metadata);


    } //END FUNCTION


    const closeOrder = async () => {

        //MAIN VALIDATION
        if(!technicalReport){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        const endpoint = "updateOrder?orderID=" + orderID;

         //
        const metadata = {
            "customer": objOrder.customer,
            "model": objOrder.model,
            "serialNumber":objOrder.serialNumber,
            "failure":objOrder.failure,
            "personContact":objOrder.personContact,
            "issuesDate": objOrder.issuesDate,
            "status": "En espera de firma del cliente",
            "address": objOrder.address,
            "tecnico": objOrder.tecnico,
            "technicalReport": technicalReport ? technicalReport.replace(/[\t\n\r\\']/g, '') : "",
            "serviceInvoice": objOrder.serviceInvoice,
            "counterDevice": counterDevice ? counterDevice.replace(/[\t\\']/g, '').trim() : "",
            "personContactData": objOrder.personContactData,
            "serviceType": serviceType,
            "notes":objOrder.notes

        };

        //
        const requestBody ="{\"metadata\":\"" + JSON.stringify(metadata).replace(/"/g, '\\"') + "\"}";

        //
        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: requestBody
        });

        const responseContent = await response.json();

        //STORE LOG INFORMATION
        storeOrderLog(orderID, sessionUser.customer_name, "Servicio Cerrado", "El técnico " + objOrder.tecnico + " cerró el servicio y completó el informe técnico");

        //Show message sweet alert
        Swal.fire({
            title: "¡Éxito!",
            text: "Operación realizada exitosamente.",
            icon: "success",
            confirmButtonText: "OK"
        });

        //CLOSE MODAL
        requestClose(false);


    } //END FUNCTION

    return (
        <>
        <Modal show={show} onShow={requestOrderInfo}  onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Cerrar Orden de Servicio | <b style={{color:"darkred"}}>N° {orderID}</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>
                    <Col xs={12} style={{lineHeight: '20px'}}>
                        
                        <span className='closeOrderlabels'>Cliente: </span>
                        <span>{objOrder.customer} </span><br />

                        <span className='closeOrderlabels'>Modelo: </span>
                        <span>{objOrder.model} </span><br />

                        <span className='closeOrderlabels'>N° Serie: </span>
                        <span>{objOrder.serialNumber}</span><br />

                        <span className='closeOrderlabels'>Falla / Detalles: </span>
                        <span>{objOrder.failure}</span><br />

                        <span className='closeOrderlabels'>Persona Contacto: </span>
                        <span>{objOrder.personContact}</span><br />

                        <span className='closeOrderlabels'>Dirección del servicio: </span>
                        <span>{objOrder.address}</span><br />

                        <span className='closeOrderlabels'>Datos de Contacto: </span>
                        <span>{objOrder.personContactData}</span><br />

                        <span className='closeOrderlabels'>Servicio Facturable: </span>
                        <span>{objOrder.serviceInvoice}</span><br />

                        <span className='closeOrderlabels'>Notas / Observaciones: </span>
                        <span>{objOrder.notes}</span><br />

                        <span className='closeOrderlabels'>Técnico: </span>
                        <span>{objOrder.tecnico}</span><br /><br />

                    </Col>
                    <hr />
                    
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Informe Técnico</Form.Label>
                             <Form.Control as="textarea" rows={5} onChange={(event)=> setTechnicalReport(event.target.value)}/><br />
                        </Form.Group>
                    </Col>

                    <hr />
                    
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Contador Equipo</Form.Label>
                             <Form.Control type="text" onChange={(event)=> setcounterDevice(event.target.value)}/><br />
                        </Form.Group>
                    </Col>

                    <hr />
                    
                    <Col xs={12}>
                        <Form.Group>
                            <Form.Label className={'newOrderlabels'}>Tipo de Servicio</Form.Label>
                            <Form.Select style={{fontSize:"14px"}} onChange={(e)=>{setServiceType(e.target.value); }} >
                                <option style={{fontSize:"14px"}}>Seleccione...</option>
                                <option style={{fontSize:"14px"}}>Remoto</option>
                                <option style={{fontSize:"14px"}}>Presencial</option>
                            </Form.Select>
                            <br />
                        </Form.Group>
                    </Col>

                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={closeOrder}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default CloseOrderModal;